export { getVirtualParent } from '@fluentui/dom-utilities';
